import PropTypes from "prop-types";
import React, { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";

import { Image } from "../Image";
import { Modal } from "../Modal";
import { PRETTY_MAX_FILE_SIZE, VALID_IMAGE_EXTENSIONS } from "../../utils/fileUtil";
import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";
import { UploadFile } from "../UploadFile";

import "./styles.scss";

export const UploadFileModal = ({
  className,
  onBackFileInputChange,
  onCancel,
  onFrontFileInputChange,
  onSubmit,
  show,
  ...props
}) => {
  const [showState, setShowState] = useState(show);

  const [frontCardImgName, setFrontCardImgName] = useState(undefined);
  const [backCardImgName, setBackCardImgName] = useState(undefined);

  const hiddenFrontFileInput = React.useRef(null);
  const hiddenBackFileInput = React.useRef(null);

  const handleFrontFileBrowseButtonClick = () => {
    hiddenFrontFileInput.current.click();
  };
  const handleBackFileBrowseButtonClick = () => {
    hiddenBackFileInput.current.click();
  };

  const handleFrontFileInputChange = (e) => {
    setFrontCardImgName(e.target.files[0].name);
    onFrontFileInputChange(e);
  };

  const handleBackFileInputChange = (e) => {
    setBackCardImgName(e.target.files[0].name);
    onBackFileInputChange(e);
  };

  const onFrontFileDelete = () => setFrontCardImgName(undefined);
  const onBackFileDelete = () => setBackCardImgName(undefined);

  return (
    <Modal className={cn("apti-UploadFileModal", className)} show={true} {...props}>
      <header className="apti-UploadFileModal__header">
        <Text type={TextTypes.heading2}>Upload Insurance Card</Text>

        <Image
          alt="close"
          className="tw:self-start"
          onClick={() => {
            setShowState(!showState);
            onCancel();
          }}
          src="icons/delete_button.svg"
        />
      </header>

      <div className="tw:flex tw:flex-col tw:gap-5">
        <Text color={TextColors.grey} type={TextTypes.paragraph}>
          Upload images of the front and back of your insurance card.
        </Text>

        <UploadFile
          files={frontCardImgName ? [frontCardImgName] : []}
          label="Upload Front of Card"
          onBrowseButtonClicked={handleFrontFileBrowseButtonClick}
          onFileDelete={onFrontFileDelete}
          placeholder="Browse files"
          required
        />

        <input
          onChange={handleFrontFileInputChange}
          ref={hiddenFrontFileInput}
          style={{ display: "none" }}
          type="file"
        />

        <UploadFile
          files={backCardImgName ? [backCardImgName] : []}
          label="Upload Back of Card"
          onBrowseButtonClicked={handleBackFileBrowseButtonClick}
          onFileDelete={onBackFileDelete}
          placeholder="Browse files"
          required
        />

        <input
          onChange={handleBackFileInputChange}
          ref={hiddenBackFileInput}
          style={{ display: "none" }}
          type="file"
        />

        <Text color={TextColors.grey} type={TextTypes.paragraph}>
          <span className="bold">Acceptable file formats:</span> {VALID_IMAGE_EXTENSIONS.join(", ")}
          <br />
          <span className="bold">Max file size:</span> {PRETTY_MAX_FILE_SIZE}
        </Text>

        <Button2 className="tw:min-w-40 tw:self-end" onPress={onSubmit}>
          Done
        </Button2>
      </div>
    </Modal>
  );
};

UploadFileModal.propTypes = {
  className: PropTypes.string,
  onBackFileInputChange: PropTypes.func,
  onCancel: PropTypes.func,
  onFrontFileInputChange: PropTypes.func,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
};

UploadFileModal.defaultProps = {
  className: undefined,
  onBackFileInputChange: () => {},
  onCancel: () => {},
  onFrontFileInputChange: () => {},
  onSubmit: () => {},
  show: false,
};
